export interface AddRequest {
  requestId: string;
  hasIdTilt: boolean;
  hasSelfieGesture: boolean;
  agreementsValidation: boolean;
  phoneValidation: boolean;
  phoneNumber: string;
  state: string;
  logSteps: boolean;
  debug: boolean;
  idModelsPath: string;
  faceModelsPath: string;
  citizenship: string;
  videoRecording: boolean;
  glareTreshold: number;
  blurTreshold: number;
  manualCaptureTimeout: number;
  redirectUrl: string;
  detectedCountryCode?: string;
}
